export default __webpack_public_path__ + "static/media/arrow-bold-forvard-all.31048fb3.svg";